import {BaseModel} from '../../common/base/model';

export class NewPortfolioModel extends BaseModel {
  constructor(data) {
    super(data, {
      securities: [],
      funds: []
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/components/newPortfolio/newPortfolio.model.js